<div fxLayout="row" id="app">
    <app-side-menu *ngIf="isLoggedIn" (closeMenu)="showMenu = false" [isShowMenu]="showMenu"></app-side-menu>
    <div class="main-page" fxLayout="column" >
        <app-top-bar *ngIf="isLoggedIn" class="top-bar mat-elevation-z4" (showMenu)="showMenu = true"></app-top-bar>
        <div class="router-contents">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>